import React, { useState, useEffect } from 'react';
import Loader from "../../../components/ui/Loader/Loader";
import HttpAPICall from "../../../services/HttpAPICall";
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import { DisplayListPagination } from '../../../components/TapUi';
import { Modal } from 'bootstrap';
import RequisitionDetailModal from './RequisitionDetailModal';
import { useSelector } from 'react-redux';

const PRHistoryContent = (props) => {

    const { itemData, warehouse_id, indent_transaction_id = '' } = props;
    const [loading, setLoading] = useState(false);
    const [reqDetailList, setReqDetailList] = useState([]);
    const [listingMeta, setListingMeta] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemName, setItemName] = useState("");
    const access_token = useSelector(state => state.auth.access_token);

    const ReqDetailModalRef = React.useRef(null);

    const requisitionReportUrl = INVENTORY_API_BASE_URL_2 + '/report/item-wise-requisition';

    const fetchPRHistoryData = async (page = 1) => {
        setLoading(true);
        let params = {
            search_warehouse_ids: warehouse_id ? [warehouse_id] : [],
            search_item_ids: itemData ? [itemData.id] : null,
            indent_transaction_id: indent_transaction_id || '',
            page: page
        };

        HttpAPICall.withAthorization('GET', requisitionReportUrl, access_token, params, {}, (resp) => {
            let respData = resp.data;
            setReqDetailList(respData.data || []);
            setListingMeta(respData);
            setCurrentPage(page);
            setItemName(itemData || "")
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    };

    useEffect(() => {
        if (itemData) {
            fetchPRHistoryData(1);
        }
    }, [itemData, warehouse_id, indent_transaction_id]);

    const reqDetailModalInit = (req_item_id) => {
        if (ReqDetailModalRef.current) {
            ReqDetailModalRef.current.modalReqInit(req_item_id);
        }
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <div className='p-1 bg-light border-bottom'>
                <table className='table table-sm mb-0 table-borderless text-sm'>
                    <tbody>
                        <tr>
                            <td style={{ width: "15%" }}>Item</td>
                            <th>{itemName?.name || "-"}</th>
                        </tr>
                        <tr>
                            <td style={{ width: "15%" }}>Item Code</td>
                            <th>{itemName?.item_code || "-"}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style={{ maxHeight: "330px", overflowY: "auto", marginTop: "8px", marginBottom: "8px" }}>
                <table className="table table-bordered bg-white table-fixed">
                    <thead className="table-secondary">
                        <tr className="text-end">
                            <th scope="col" style={{ width: "12%" }} className="text-start">Req ID</th>
                            <th scope="col" style={{ width: "15%" }} className="text-center">Transaction Date</th>
                            <th scope="col" style={{ width: "25%" }} className="text-center">Warehouse</th>
                            <th scope="col" style={{ width: "10%" }}>Req Qty</th>
                            <th scope="col" style={{ width: "12%" }}>Pending Qty</th>
                            <th scope="col" style={{ width: "10%" }} className='text-center'>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reqDetailList.length > 0 ? (
                            reqDetailList.map((rowData, k) => (
                                <tr key={k}>
                                    <td>
                                        <a href="#" role="button" className='link-primary' onClick={() => reqDetailModalInit(rowData.transaction_id)}>
                                            {rowData.transaction_id}
                                        </a>
                                    </td>
                                    <td className='text-center'>{rowData.transaction_date_display}</td>
                                    <td>{rowData.warehouse_name}</td>
                                    <td className='text-end'>{rowData.qty}</td>
                                    <td className='text-end'>{rowData.pending_qty}</td>
                                    <td className='text-center'>{rowData.status && rowData.status.name ? rowData.status.name : "-"}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td className="text-center" colSpan={6}>No Record Found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <DisplayListPagination
                meta={listingMeta}
                onPageChange={(e) => fetchPRHistoryData(e.selected + 1)}
            />
            <RequisitionDetailModal parentProps={props} ref={ReqDetailModalRef} />
        </>
    );
};

export default PRHistoryContent;